import { RampWithNameTransform, TopModelChildrenMerge, } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export function TableStructure(props) {
    var primaryDimensionList = props.primaryDimensionList, secondaryDimensionList = props.secondaryDimensionList, direction = props.direction, wrapping = props.wrapping, multiBody = props.multiBody, children = props.children;
    return (React.createElement(TopModelChildrenMerge, null,
        children,
        React.createElement(RampWithNameTransform, { rampName: "Base", primaryDimensionList: primaryDimensionList, secondaryDimensionList: secondaryDimensionList, direction: direction, wrapping: wrapping, multiBody: multiBody })));
}
